import { useEffect } from "react";
import { getSid } from "../../lib/routing";
import { history } from "../../redux/configureStore";

export const MagicLinkVerify = () => {
  if (!getSid()) history.push("/public/magic-link?err=invalid-token");
  useEffect(() => {
    handleMagicLinkVerify();
  }, []);
  return <br />;
};
export const handleMagicLinkVerify = async () => {
  const sid = getSid().replace(/\s/g, "+");
  const body = JSON.stringify({ sid });
  const response = await fetch("/research/japi/user/magic-link", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
  });

  if (response.redirected === true) {
    window.location.assign(response.url);
  } else {
    history.push("/public/magic-link?err=fail");
  }
};
